(function($) {$(document).ready(function() {
	
	const $mobileLists = $('.link-lists.mobile');
	const $input = $mobileLists.find('.link-lists__input');

	$('.link-lists__list-title').on('click', toggleList);
	$('.link-lists__form').on('submit', filterCourses);
	$input.on('search', filterCourses);

	function toggleList(event) {
		const $this = $(this);

		$this
			.siblings('.link-lists__list')
			.slideToggle()
			.parent()
			.toggleClass('open');
	}

	function filterCourses(event) {
		if (event) event.preventDefault();

		const term = $input.val();

		$mobileLists
			.find('.link-lists__list')
			.eq(0)
			.find('.link-lists__link')
			.removeClass('filtered')
			.each((index, el) => {
				const $el = $(el);
				const title = $el.text();
				const found = title.toLowerCase().indexOf(term.toLowerCase()) !== -1;
				if (!found) $el.addClass('filtered');
			});
	}

});;jQueryBridget("flickity", Flickity, $);})(window.NEW_jquery);